export const TextColorsRaw = {
	PRIMARY: '#000000',
	SECONDARY: '#3e434f',
	TERTIARY: '#697284',
	QUATERNARY: '#8c96ab',
	HIGHLIGHT_TITLE: '#001642',
	HIGHLIGHT_ACTION: '#0069de',
	HIGHLIGHT_KEYINFO: '#05403e',
	STATUS_INFO: '#0069de',
	STATUS_WARNING: '#a64708',
	STATUS_ERROR: '#b3130f',
	STATUS_ERROR_DARKER: '#f00b05',
	STATUS_SUCCESS: '#4f9e52',
	OPPOSITE_PRIMARY: '#ffffff',
	OPPOSITE_SECONDARY: '#dce2ee',
	OPPOSITE_TERTIARY: '#acb6cc'
} as const

export const TextColors = {
	PRIMARY: 'text.primary',
	SECONDARY: 'text.secondary',
	TERTIARY: 'text.tertiary',
	QUATERNARY: 'text.quaternary',
	HIGHLIGHT_TITLE: 'text.highlight_title',
	HIGHLIGHT_ACTION: 'text.highlight_action',
	HIGHLIGHT_KEYINFO: 'text.highlight_keyinfo',
	STATUS_INFO: 'text.status_info',
	STATUS_WARNING: 'text.status_warning',
	STATUS_ERROR: 'text.status_error',
	STATUS_ERROR_DARKER: 'text.status_error_darker',
	STATUS_SUCCESS: 'text.status_success',
	OPPOSITE_PRIMARY: 'text.opposite_primary',
	OPPOSITE_SECONDARY: 'text.opposite_secondary',
	OPPOSITE_TERTIARY: 'text.opposite_tertiary'
} as const

export const BgColorsRaw = {
	Z0: '#8e98ad',
	Z1: '#c5cee0',
	Z2: '#dce2ee',
	Z3: '#e7ebf3',
	Z4: '#f2f4f8',
	Z5: '#ffffff',
	HIGHLIGHT_Z0: '#E9F5FD',
	HIGHLIGHT_Z1: '#def1ff',
	HIGHLIGHT_Z2: '#e9f5fd',
	STATUS_INFO: '#e9f5fd',
	STATUS_WARNING: '#ffede1',
	STATUS_ERROR: '#fff9f8',
	OPPOSITE_Z2: '#0069de',
	OPPOSITE_Z3: '#0180ff',
	NEUTRAL_Z0: '#F7F7F7',
	NEUTRAL_DARK: '#1B1B1D',
	NEUTRAL_DARK_HOVER: '#353538'
} as const

export const BgColors = {
	Z0: 'bg.z0',
	Z1: 'bg.z1',
	Z2: 'bg.z2',
	Z3: 'bg.z3',
	Z4: 'bg.z4',
	Z5: 'bg.z5',
	HIGHLIGHT_Z0: 'bg.highlight_z0',
	HIGHLIGHT_Z1: 'bg.highlight_z1',
	HIGHLIGHT_Z2: 'bg.highlight_z2',
	STATUS_INFO: 'bg.status_info',
	STATUS_WARNING: 'bg.status_warning',
	STATUS_ERROR: 'bg.status_error',
	OPPOSITE_Z2: 'bg.opposite_z2',
	OPPOSITE_Z3: 'bg.opposite_z3',
	NEUTRAL_Z0: 'bg.neutral_z0',
	NEUTRAL_DARK: 'bg.neutral_dark',
	NEUTRAL_DARK_HOVER: 'bg.neutral_dark_hover'
}

export const BrandColorsRaw = {
	PRIMARY: '#0180FF',
	SECONDARY: '#60AFFF'
} as const

export const BrandColors = {
	PRIMARY: 'brand.primary',
	SECONDARY: 'brand.secondary'
} as const

export const FontFamily = {
	DEGULAR: "'Degular', sans-serif",
	MONTSERRAT: "'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
} as const

export const BorderRadiusRaw = {
	XS: '2px',
	S: '4px',
	SM: '6px',
	M: '8px',
	L: '12px',
	XL: '16px',
	'2XL': '20px',
	'3XL': '24px',
	'4XL': '32px'
} as const

export const SpacingRaw = {
	'3XS': '2px',
	'2XS': '4px',
	XS: '8px',
	S: '12px',
	SM: '16px',
	M: '20px',
	ML: '24px',
	L: '32px',
	XL: '40px',
	'2XL': '48px',
	'3XL': '56px'
} as const

export const Spacing = {
	'3XS': '3xs',
	'2XS': '2xs',
	XS: 'xs',
	S: 's',
	SM: 'sm',
	M: 'm',
	ML: 'ml',
	L: 'l',
	XL: 'xl',
	'2XL': '2xl',
	'3XL': '3xl'
} as const

export const BorderRadius = {
	XS: 'xs',
	S: 's',
	SM: 'sm',
	M: 'm',
	L: 'l',
	XL: 'xl',
	'2XL': '2xl',
	'3XL': '3xl',
	'4XL': '4xl'
} as const
